import React, { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import { useCookies } from 'react-cookie'

import PhatButton from 'components/formElements/PhatButton'
import ContestSubmissionOverlay from 'components/comments/ContestSubmission/ContestSubmissionOverlay'
import Link from 'components/elements/Link'

import styles from './contestSubmissionTabs.module.scss'

type Props = { threadId: number | string; showAll: boolean }

const ContestSubmissionsGrid = ({ threadId, showAll }: Props) => {
  const router = useRouter()

  const [{ tbId: userId }] = useCookies(['tbId'])

  const [submissionOverlay, setSubmissionOverlay] = useState(false)

  return (
    <div className={styles.container}>
      <div className={styles.options}>
        <div className={styles.submitButton}>
          {!!userId ? (
            <PhatButton color="orange" onClick={() => setSubmissionOverlay(true)}>
              Submit a deck to this contest
            </PhatButton>
          ) : (
            <Link href="/login" className={styles.loginLink}>
              <PhatButton color="orange">Login to submit a deck</PhatButton>
            </Link>
          )}
        </div>
      </div>
      <div className={styles.tabs}>
        <Link
          className={router.pathname === '/contest/[threadId]' ? styles.selected : ''}
          href={`/contest/${threadId}/`}>
          Submissions
        </Link>
        <Link
          className={router.pathname === '/contest/discussion/[threadId]' ? styles.selected : ''}
          href={`/contest/discussion/${threadId}/`}>
          Discussion
        </Link>
      </div>

      <ContestSubmissionOverlay
        open={submissionOverlay}
        onClose={() => setSubmissionOverlay(false)}
        threadId={threadId}
      />
    </div>
  )
}

export default ContestSubmissionsGrid
